var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndividual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.666,4C4.666,2.675 5.711,1.6 7,1.6C8.288,1.6 9.333,2.675 9.333,4C9.333,5.325 8.288,6.4 7,6.4C5.711,6.4 4.666,5.325 4.666,4ZM7,-0C4.852,-0 3.111,1.791 3.111,4C3.111,6.209 4.852,8 7,8C9.148,8 10.889,6.209 10.889,4C10.889,1.791 9.148,-0 7,-0ZM3.889,9.6C2.857,9.6 1.868,10.021 1.139,10.772C0.41,11.522 0,12.539 0,13.6L0,15.2C0,15.642 0.348,16 0.778,16C1.207,16 1.556,15.642 1.556,15.2L1.556,13.6C1.556,12.963 1.801,12.353 2.239,11.903C2.677,11.453 3.27,11.2 3.889,11.2L10.111,11.2C10.73,11.2 11.323,11.453 11.761,11.903C12.199,12.353 12.444,12.963 12.444,13.6L12.444,15.2C12.444,15.642 12.793,16 13.222,16C13.652,16 14,15.642 14,15.2L14,13.6C14,12.539 13.59,11.522 12.861,10.772C12.132,10.021 11.142,9.6 10.111,9.6L3.889,9.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/Individual.51c16c71427cbe555f4f01d3c73f7448.svg";
export { ForwardRef as ReactComponent };